import { BUILTIN_CLASS_ICON_SOURCES } from './builtinClassIconData.js';
import { BUILTIN_ELEMENT_ICON_SOURCES } from './builtinElementIconData.js';

const text = (value) => String(value ?? '').trim();

function normalizeClassIconKey(value) {
  const normalized = text(value).toLocaleLowerCase('ko-KR');
  if (/defender|defence|defense|방어/.test(normalized)) return 'defender';
  if (/supporter|support|지원|서포터/.test(normalized)) return 'supporter';
  if (/attacker|attack|화력|공격/.test(normalized)) return 'attacker';
  return '';
}

function normalizeElementIconKey(value) {
  const normalized = text(value).toLocaleLowerCase('ko-KR');
  if (/작열|fire/.test(normalized)) return 'fire';
  if (/수냉|water/.test(normalized)) return 'water';
  if (/전격|elect/.test(normalized)) return 'electric';
  if (/풍압|wind/.test(normalized)) return 'wind';
  if (/철갑|iron/.test(normalized)) return 'iron';
  return '';
}

export function resolveBuiltinNikkeIconSource(type, ...keys) {
  const kind = text(type).toLocaleLowerCase('ko-KR');
  if (kind === 'class') {
    for (const key of keys.flat()) {
      const classKey = normalizeClassIconKey(key);
      if (classKey) return BUILTIN_CLASS_ICON_SOURCES[classKey];
    }
    return '';
  }
  if (kind === 'element') {
    for (const key of keys.flat()) {
      const elementKey = normalizeElementIconKey(key);
      if (elementKey) return BUILTIN_ELEMENT_ICON_SOURCES[elementKey];
    }
  }
  return '';
}

export function normalizeNikkeIconSource(row = {}) {
  const imageUrl = text(row.image_url || row.imageUrl);
  if (imageUrl) return imageUrl;
  const imageData = text(row.image_data || row.imageData);
  if (!imageData) return '';
  return imageData.startsWith('data:') ? imageData : `data:image/png;base64,${imageData}`;
}

export function nikkeIconLookupKey(type, key) {
  return `${text(type).toLocaleLowerCase('ko-KR')}:${text(key).toLocaleLowerCase('ko-KR')}`;
}

export function buildNikkeIconLookup(rows = []) {
  const lookup = new Map();
  for (const row of Array.isArray(rows) ? rows : []) {
    const type = text(row.icon_type || row.iconType);
    const iconKey = text(row.icon_key || row.iconKey);
    if (!type || !iconKey || row.active === false) continue;
    const icon = {
      type,
      iconKey,
      label: text(row.label),
      imageUrl: normalizeNikkeIconSource(row),
      aliases: Array.isArray(row.aliases) ? row.aliases.map(text).filter(Boolean) : [],
      metadata: row.metadata && typeof row.metadata === 'object' ? row.metadata : {},
    };
    for (const key of [iconKey, icon.label, ...icon.aliases]) {
      if (key) lookup.set(nikkeIconLookupKey(type, key), icon);
    }
  }
  return lookup;
}

export function findNikkeIcon(lookup, type, ...keys) {
  for (const key of keys.flat()) {
    const icon = lookup?.get(nikkeIconLookupKey(type, key));
    if (icon) return icon;
  }
  return null;
}
